export default __webpack_public_path__ + "static/media/block.673f29f3.svg";